export const select_campaign_error_obj = (state) => {
  return state?.formErrorsCampaign;
};
